{
  "PendingInvites": "Invitaciones pendientes",
  "delete": "Eliminar",
  "sendANudge": "Enviar recordatorio",
  "NoPendingInvitations": "No hay invitaciones pendientes",
  "InviteTeammate": "Invita a un miembro de equipo",
  "InviteTeammateContinued": "(Solo para Rebels)",
  "Email": "Email",
  "sendInvite": "Enviar invitación",

  "InviteTitle": "Elige el rol al que desea invitar:",
  "SelectRole": "Selecciona un rol",
  "SelectRoles": "Seleccionar rol (s)",
  "WorkingOnInnovation": "Trabajando en innovación",
  "Supporter": "Soporte",
  "LendingExpertise": "Compartiendo experiencia profesional",
  "General": "General",
  "NoRole": "Sin rol",
  "InviteViaEmails": "Invitar por correo electrónico",
  "InvitePlaceholder": "Agrega varias direcciones de correo electrónico una a la vez",
  "TypeEmail": "Escriba una dirección de correo electrónico y presiona 'Enter'",
  "PersonalizeInvitationMessage": "Personaliza tu invitación con un mensaje",
  "AddYourMessage": "Agrega tu mensaje",
  "optional": "opcional",
  "AddToActiveGroup": "Agregar al grupo activo (opcional)",
  "AddMessage": "Esto los agregará como miembro",
  "NewGroup": "nuevo grupo",
  "AddNameOfGroup": "agregar el nombre del grupo",
  "createGroup": "crea un grupo",
  "Finish": "Terminar",
  "close": "Cerrar  ",
  "send": "Enviar",
  "invites": "Invitaciones",
  "SelectRoleFirst": "primero seleccione el tipo de rol",
  "InviteHubAdmin": "Para invitar a un administrador del Hub",
  "ClickHere": "haz clic aquí.",
  "SubscriptionHeader": "Su plan de suscripción permite 3 grupos activos.",
  "SubscriptionMessage": "Actualiza para desbloquear grupos activos ilimitados",
  "SubscriptionHint": "Sugerencia: puedes desactivar otro grupo para dejar espacio para este",
  "Upgrade": "Mejorar",
  "Cancel": "Cancelar",
  "InvitesSent": "Invitación(es) enviada(s) correctamente.",
  "IncorrectEmail": "Oh no. Parece que estas escribiendo un correo electrónico incorrecto.",
  "InviteSentWithoutEmail": "Oh no. Parece que envía una invitación sin un correo electrónico.",
  "Invite Your Teammates": "Invita a tus compañeros de equipo",
  "Teammates can take challenges and strengthen your project.": "Los compañeros de equipo pueden tomar desafíos y fortalecer tu proyecto.",
  "Add Email(s)": "Añadir correo(s) electrónico",
  "Invite Teammates": "Invitar a compañeros de equipo",
  "Invite People": "Invitar a la gente",
  "Owner": "Propietario",
  "Owners can do pretty much what they want with your project. Once assigned, ownership cannot be revoked.": "Los propietarios pueden hacer prácticamente lo que quieran con su proyecto. Una vez asignado, la propiedad no se puede revocar.",
  "Admin": "Admin",
  "Admins can manage users and project settings.": "Admins pueden gestionar usuarios y configuraciones del proyecto.",
  "Member": "Miembro",
  "Members can take challenges and strengthen your project.": "Los miembros pueden tomar desafíos y fortalecer su proyecto",
  "Support Member": "Miembro de soporte",
  "Supporters can see your content before you make it public.": "Los miembros de soporte pueden ver su contenido antes de hacerlo público."
}
